class InputValidator {
  constructor(inputElement, options = {}) {
    this.inputElement = inputElement;
    if (inputElement === null) {
      throw new ReferenceError('Input element not found');
    }
    this.errorElement = document.getElementById(inputElement.id + '-error');
    if (this.errorElement === null) {
      throw new ReferenceError('Error element not found');
    }
    this.options = {
      errorClass: 'has_error',
      ...options,
    };
  }

  validate(validationFunction, errorMessage) {
    if (typeof validationFunction !== 'function') {
      throw new TypeError('validationFunction must be a function');
    }
    if (validationFunction(this.inputElement.value)) {
      this.clearError();
      return true;
    } else {
      this.showError(errorMessage);
      return false;
    }
  }

  showError(errorMessage) {
    const errorIcon = '<span class="icon icon_exclamation icon_margin" aria-hidden="true"></span>';
    this.inputElement.classList.add(this.options.errorClass);
    this.inputElement.setAttribute('aria-invalid', 'true');
    this.errorElement.innerHTML = errorIcon + errorMessage;
    this.errorElement.classList.add(this.options.errorClass); // Ensure error element is visible
  }

  clearError() {
    this.inputElement.classList.remove(this.options.errorClass);
    this.inputElement.setAttribute('aria-invalid', 'false');
    this.errorElement.innerHTML = '';
    this.errorElement.classList.remove(this.options.errorClass); // Ensure error element is hidden
  }

  static focusFirstInvalid(container = document) {
    const el = container.querySelector('[aria-invalid="true"], .has_error');
    if (el) {
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '-1');
      }
      el.focus();
      el.scrollIntoView({block: 'center'});
      return true;
    }
    return false;
  }

  static required(value) {
    return value.trim() !== '';
  }

  static email(value) {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value);
  }

  static password(value) {
    return value.length >= 8;
  }

  static defaultMessages = {
    required: 'Bitte fülle dieses Feld aus.',
    email: 'Bitte gib eine korrekte E-Mail-Adresse wie z.B. max@muster.de ein.',
    password: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
  };
}

export default InputValidator;
